module.exports = function(angular, app) {
    var FilterTypes = require('../filter_types').FilterTypes;
    var FilterTypesList = require('../filter_types').FilterTypesList;
    var GroupFilterNames = require('../filter_types').GroupFilterNames;

    function deepQueryFilter($sce, DeepQueryDimensions) {
        return {
            restrict: 'E',
            scope: {
                filter: '=bindFilter',
                source: '='
            },
            templateUrl: '/tpl/deep-query/filter.html',
            compile: function(element, attrs) {
                var filterListFn;

                switch(attrs.filterType || 'where') {
                    case 'subfilter':
                        filterListFn = function(type) { return !type.noSubFilter; };
                        break;
                    case 'having':
                        filterListFn = function(type) { return !type.noHaving; };
                        break;
                    default:
                        filterListFn = function() { return true; };
                }

                return function link(scope, element, attrs) {
                    scope.filterTypes = FilterTypes;
                    scope.filterTypesList = FilterTypesList;

                    var filterType = scope.filterType = function filterType(filter) {
                        return filter._type || (filter._type = FilterTypes[filter.type]);
                    };

                    scope.hasSingleValue = function hasSingleValue(filter) {
                        return angular.isDefined(filter.value);
                    };

                    scope.hasManyConstValues = function hasManyConstValues(filter) {
                        return angular.isArray(filter.values) && !!filterType(filter).valuesLength;
                    };

                    scope.hasManyVariableValues = function hasManyVariableValues(filter) {
                        return angular.isArray(filter.values) && !filterType(filter).valuesLength;
                    };

                    scope.filterSymbol = function filterSymbol(filter) {
                        var type = filterType(filter);
                        return filter.negative && type.nsymbol || type.symbol;
                    };

                    function makeFilter(type) {
                        if (!type) return null;
                        var filter = angular.copy(type.template);
                        filter._type = type;
                        return filter;
                    }

                    var createFilter = scope.createFilter = function createFilter(type, parent) {
                        var filter = makeFilter(type);
                        if (parent) {
                            filter.parent = parent;
                            parent.children.push(filter);
                        } else {
                            scope.filter = filter;
                        }
                    };

                    var filterIndex = scope.filterIndex = function filterIndex(filter) {
                        var children = filter.parent.children;
                        for(var i = children.length; i-- > 0; )
                            if (children[i] === filter)
                                return i;
                    };

                    var replaceFilter = scope.replaceFilter = function replaceFilter(oldfilter, newfilter) {
                        var parent = oldfilter.parent;
                        if (parent) {
                            var index = filterIndex(oldfilter);
                            if (index != null)
                                parent.children.splice(index, 1, newfilter);
                            newfilter.parent = parent;
                        } else {
                            newfilter.parent = null;
                            scope.filter = newfilter;
                        }
                    };

                    scope.removeFilter = function removeFilter(filter) {
                        var parent = filter.parent;
                        if (parent) {
                            var index = filterIndex(filter);
                            var children = parent.children;
                            if (index != null)
                                children.splice(index, 1);
                            if (children.length === 1)
                                replaceFilter(parent, children[0]);
                        } else {
                            scope.filter = null;
                        }
                    };

                    function nextIn(item, items) {
                        return items[(items.indexOf(item) + 1) % items.length];
                    }

                    scope.groupFilters = function(filter, defaultTypeId) {
                        var typeId = filter.parent ? nextIn(filter.parent.type, GroupFilterNames) : defaultTypeId;
                        var newFilter = makeFilter(FilterTypes[typeId]);
                        replaceFilter(filter, newFilter);
                        newFilter.children.push(filter);
                        filter.parent = newFilter;
                        createFilter(FilterTypesList[0], newFilter);
                    };

                    var toggleTypeRecursive = scope.toggleTypeRecursive = function toggleTypeRecursive(filter) {
                        filter || (filter = scope.filter);
                        var children = filter.children;
                        if (children) {
                            filter.type = nextIn(filter.type, GroupFilterNames);
                            delete filter._type;
                            angular.forEach(children, toggleTypeRecursive);
                        }
                    };

                    scope.changeFilterType = function changeFilterType(type, filter) {
                        if (type.id == filter.type)
                            return;
                        var template = type.template;
                        filter.type = template.type;
                        delete filter._type;
                        for(var name in template) {
                            if (typeof filter[name] !== typeof template[name])
                                filter[name] = angular.copy(template[name]);
                        }
                        for(var name in filter) {
                            if (!(name in template))
                                delete filter[name];
                        }
                        if (type.valuesLength && filter.values.length != type.valuesLength) {
                            filter.values.splice(2);
                            while(filter.values.length < type.valuesLength)
                                filter.values.push("");
                        }
                    };

                    scope.toggleState = function toggleState(object, property) {
                        if (object) object[property] = !object[property];
                    };

                    scope.taDimensions = function taDimensions(viewValue) { // TODO: export to separate directive
                        return DeepQueryDimensions.getNamesFiltered(scope.source, viewValue, 3);
                    };

                    scope.isNotGrouping = function(value) {
                        return filterListFn(value) && !value.isGrouping;
                    };

                    scope.filterTitle = function(type) {
                        if (type.symbol !== type.name)
                            return $sce.trustAsHtml(type.name + '<span class="badge"><tt>' + type.symbol + '</tt></span>');
                        else
                            return type.name;
                    };

                    scope.popFilterValue = function(filter) {
                        filter.values.pop();
                    };

                    scope.addFilterValue = function(filter) {
                        filter.values.push("");
                    };

                }
            }
        };
    }

    app.directive('deepQueryFilter', ['$sce', 'DeepQueryDimensions', deepQueryFilter]);
};
